<template>
  <div class="dashboard">
    <app-view-layout
      header="Pracownicy"
      fluid
    >
      <template #toolbarMenu>
        <v-autocomplete
          :value="selectedFilters.roleIds"
          :items="filtersOptions.roles"
          item-value="id"
          item-text="label"
          placeholder="Rola"
          multiple
          clearable
          v-bind="staticData.selectProps"
          class="width-320"
          @input="filterDashboard"
        >
          <template #selection="{ item, index }">
            <AppMultiselectChoices
              :index="index"
              :array-length="selectedFilters.roleIds.length"
              :label="item.label"
            />
          </template>
        </v-autocomplete>
      </template>

      <template #content>
        <AppSearchInput
          class="mb-4"
          search-placeholder="Wyszukaj"
          @search="searchQuery = $event"
        />

        <v-data-table
          class="view-table"
          :headers="staticData.headers"
          :items="dashboardData"
          :items-per-page="12"
          fixed-header
          show-expand
          single-expand
          :search="searchQuery"
          no-result-text="Brak pasujących pracowników"
          :loading="isProcessing"
          loading-text="Wyszukiwanie pracowników"
          :footer-props="{
            itemsPerPageOptions: [12,24,36],
            itemsPerPageText: 'Pozycji na stronę',
          }"
        >
          <template #no-results>
            <AppEmptyList class="projects-index__empty py-10" />
          </template>

          <template #[`item.roles`]="{item}">
            <AppLimitedItems
              :items="item.roles"
              :visible-items="2"
              label="label"
            />
          </template>

          <template #expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              class="px-0"
            >
              <v-data-table
                class="expanded-table"
                :headers="staticData.expandedHeaders"
                :items="item.activeProjects.map((p,i) => ({...p, index: i+1}) )"
                :items-per-page="-1"
                fixed-header
                no-data-text="Brak aktywnych projektów"
                hide-default-footer
              >
                <template #[`item.name`]="{item:project}">
                  <router-link :to="{ name: 'project-single', params: { id: project.id } }">
                    <h5 class="black--text min-w-150 max-w-300 underlined-hover">
                      {{ project.name }}
                    </h5>
                  </router-link>
                </template>
                <template #[`item.status`]="{item:project}">
                  <div class="d-flex align-center">
                    <AppStatus
                      :status-text="project.status"
                      multiline
                    />
                  </div>
                </template>
                <template #[`item.deadline`]="{item:project}">
                  {{ formatDateOutput([project.deadline]) }}
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import AppStatus from '@/components/UI/AppStatus.vue';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';
import AppMultiselectChoices from '@/components/UI/AppMultiselectChoices.vue';
import AppLimitedItems from '@/components/UI/AppLimitedItems.vue';
import props from '@/helpers/componentsProps';
import utils from '@/helpers/utils';

const headers = [
  { text: 'Imię i nazwisko', value: 'name' },
  { text: 'Role', value: 'roles' },
  { text: 'Całkowita liczba projektów', value: 'allProjectsCount' },
  { text: 'Liczba otwartych projektów', value: 'activeProjectsCount' },
];

const expandedHeaders = [
  { text: 'L.P.', value: 'index' },
  { text: 'ID projektu', value: 'id' },
  { text: 'Nazwa projektu', value: 'name' },
  { text: 'Termin zakończenia', value: 'deadline' },
  { text: 'Typ projektu', value: 'projectType' },
  { text: 'Status projektu', value: 'status' },
];

export default {
  components: {
    AppViewLayout,
    ProjectCard,
    AppEmptyList,
    AppStatus,
    AppSearchInput,
    AppMultiselectChoices,
    AppLimitedItems,
  },

  data: () => ({
    searchQuery: '',
    staticData: {
      headers,
      expandedHeaders,
      selectProps: props.select,
    },
  }),

  computed: {
    ...mapState('dashboard', [
      'dashboardData',
      'isProcessing',
    ]),
    ...mapState('filters', [
      'filtersOptions',
      'selectedFilters',
    ]),

  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchDashboardData();
    });
  },

  methods: {
    ...mapActions('dashboard', [
      'fetchDashboardData',
    ]),
    ...mapActions('filters', [
      'setFilters',
    ]),
    formatDateOutput: utils.formatDateOutput,
    filterDashboard(filterValue) {
      this.setFilters({ roleIds: filterValue })
        .then(() => {
          this.fetchDashboardData();
        });
    },
    getRoles(roles, end = roles.length, start = 0) {
      return roles.map((role) => role.label).slice(start, end).join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &__empty {
    min-height: calc(100vh - 220px);
  }
  .view-table::v-deep  .v-data-table__wrapper {
    max-height: calc(100vh - 300px);
  }

  .expanded-table::v-deep td {
    height: 54px !important;
  }
}
</style>
